import { mapKeys } from 'lodash-es'

export const SUCCESS = 'SUCCESS'
export const PARTIAL_SUCCESS = 'PARTIAL_SUCCESS'
export const ERROR = 'ERROR'
export const NOT_VALIDATED = 'NOT_VALIDATED'

export const MENU_VALIDATION_STATUSES = mapKeys(
  [
    { name: 'Success', value: SUCCESS },
    { name: 'Partial Success', value: PARTIAL_SUCCESS },
    { name: 'Error', value: ERROR },
    { name: 'Not Validated', value: NOT_VALIDATED },
  ],
  'value',
)
